// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelFormBody-FieldSkeleton_cls1__YkQwt","cls2":"PaymentChannelFormBody-FieldSkeleton_cls2__qAutR PaymentChannelFormBody-FieldSkeleton_cls1__YkQwt"};